module.exports = __webpack_public_path__ + "static/rumbambar-e2873bf0b29fdd6847d2d5021e0e21af.svg";